[
  {
    "pageName": "Dashboard",
    "hasChildren": false,
    "isActive": true,
    "route": "/main/landing-page",
    "icon": "landing-page",
    "ref": "landing-page",
    "menuGroup": "menu"
  },
  {
    "pageName": "Noise Word Handling",
    "hasChildren": true,
    "isActive": true,
    "route": "/main/noise-management",
    "icon": "ebook-repository",
    "ref": "noise-management",
    "menuGroup": "pages",
    "children": [
      {
        "pageName": "Noise Word Library",
        "ref": "noise-management/noise-dictionary-list",
        "route": "/main/noise-management/noise-dictionary-list"
      },
      {
        "pageName": "Noise Word Logs",
        "ref": "noise-management/noise-word-logs",
        "route": "/main/noise-management/noise-word-logs"
      }
    ]
  },
  {
    "pageName": "Chatbot Configuration",
    "hasChildren": true,
    "isActive": true,
    "route": "/main/chatbot-configuration",
    "icon": "configuration",
    "ref": "chatbot-configuration",
    "menuGroup": "pages",
    "children": [
      {
        "pageName": "Knowledge Base",
        "ref": "chatbot-configuration/knowledge-base",
        "route": "/main/chatbot-configuration/knowledge-base"
      },
      {
        "pageName": "Knowledge Sources",
        "ref": "chatbot-configuration/knowledge-sources",
        "route": "/main/chatbot-configuration/knowledge-sources"
      },
      {
        "pageName": "Voice Settings",
        "ref": "chatbot-configuration/voice-settings",
        "route": "/main/chatbot-configuration/voice-settings"
      },
      {
        "pageName": "General Settings",
        "ref": "chatbot-configuration/general-settings",
        "route": "/main/chatbot-configuration/general-settings"
      }
    ]
  },
  {
    "pageName": "Chatbot Interactions",
    "hasChildren": false,
    "isActive": true,
    "route": "/main/chatbot-interactions",
    "icon": "search+",
    "ref": "chatbot-interactions",
    "menuGroup": "pages"
  },
  {
    "pageName": "Reported Messages",
    "hasChildren": false,
    "isActive": true,
    "route": "/main/reported-messages",
    "icon": "screening",
    "ref": "reported-messages",
    "menuGroup": "pages"
  },
  {
    "pageName": "Web Search",
    "hasChildren": false,
    "isActive": true,
    "route": "/main/web-search",
    "icon": "search+",
    "ref": "web-search",
    "menuGroup": "pages"
  },
  {
    "id": "trending-topics",
    "pageName": "Trending Topics",
    "hasChildren": false,
    "isActive": true,
    "route": "/trending-topics",
    "icon": "analytics",
    "ref": "trending-topics",
    "menuGroup": "pages"
  },
  {
    "pageName": "User Management",
    "hasChildren": true,
    "route": null,
    "isActive": true,
    "icon": "user-management",
    "ref": "user-management",
    "menuGroup": "general",
    "children": [
      {
        "pageName": "User",
        "ref": "user-management/user-list",
        "route": "/main/user-management/user-list"
      },
      {
        "pageName": "Role",
        "ref": "user-management/roles",
        "route": "/main/user-management/roles"
      },
      {
        "pageName": "User Role Mapping",
        "ref": "user-management/user-role-mapping",
        "route": "/main/user-management/user-role-mapping"
      }
    ]
  },
  {
    "pageName": "User Logging",
    "hasChildren": false,
    "isActive": true,
    "route": "/main/user-logging",
    "icon": "fatca-reporting",
    "ref": "user-logging",
    "menuGroup": "general"
  },
  {
    "pageName": "Usage Management",
    "hasChildren": false,
    "isActive": true,
    "route": "/main/usage-management",
    "icon": "configuration",
    "ref": "usage-management",
    "menuGroup": "general"
  },
  {
    "pageName": "Channel Management",
    "hasChildren": false,
    "isActive": true,
    "route": "/main/channel-management",
    "icon": "channel-management",
    "ref": "channel-management",
    "menuGroup": "pages"
  },
  {
    "pageName": "Out of Scope",
    "hasChildren": false,
    "isActive": true,
    "route": "/main/out-of-scope",
    "icon": "info-circle",
    "ref": "out-of-scope",
    "menuGroup": "pages"
  },
  {
    "pageName": "Session Drop-Off",
    "hasChildren": false,
    "isActive": true,
    "route": "/main/session-drop-off",
    "icon": "analytics",
    "ref": "session-drop-off",
    "menuGroup": "pages"
  },
  {
    "pageName": "FAQ Management",
    "hasChildren": false,
    "isActive": true,
    "route": "/main/faq-management",
    "icon": "info-circle",
    "ref": "faq-management",
    "menuGroup": "pages"
  },
  {
    "pageName": "Default Questions",
    "hasChildren": false,
    "isActive": true,
    "route": "/main/default-questions",
    "icon": "info-circle",
    "ref": "default-questions",
    "menuGroup": "pages"
  },
  {
    "pageName": "Document Link",
    "hasChildren": false,
    "isActive": true,
    "route": "/main/knowledge-intake",
    "icon": "case-management",
    "ref": "knowledge-intake",
    "menuGroup": "pages"
  },
  {
    "pageName": "Knowledge Base",
    "hasChildren": false,
    "isActive": true,
    "route": "/main/context-management",
    "icon": "configuration",
    "ref": "context-management",
    "menuGroup": "pages"
  },
  {
    "pageName": "Error Management",
    "hasChildren": false,
    "isActive": true,
    "route": "/main/error-management",
    "icon": "info-circle",
    "ref": "error-management",
    "menuGroup": "general"
  },
  {
    "pageName": "Audit Trail",
    "hasChildren": false,
    "route": "/main/audit-trail",
    "icon": "audit-trail",
    "ref": "audit-trail",
    "menuGroup": "general"
  }
]
